module.exports = __webpack_public_path__ + "static/logo.a05a170f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/logo.png
// module id = 688
// module chunks = 35783957827783